import { Box, Container, Grid, Paper, Typography, Icon, IconButton, CircularProgress } from '@material-ui/core';
import React, { useState, useEffect, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import NavBar_emp from '../NavBar_emp'
import bgimg from './mainbg.jpg';
import srch from './searchicon.svg';
import pin from './pincodeicon.svg';
import briefcase from './briefcase.svg';
import ContactIcon from './contact.svg';
import ContactHoverIcon from './contacthover.svg';
import DollarSign from './dollarsign.svg';
import Modal from '@mui/material/Modal'
import { useHistory } from 'react-router-dom';
import EyesImg from '../../assets/eyes.png';
import ClicksImg from '../../assets/clicks.png';
import SchoolLogo from './schoollogo.svg';
import SmolBag from '../../assets/smolBag.png';
import HeartIcon from './heart.svg';
import HeartOnIcon from './hearton.svg';
import ProfileImg1 from './demoprofile1.svg';
import ProfileImg2 from './demoprofile2.svg';
import ProfileImg3 from './demoprofile3.svg';
import ProfileImg4 from './demoprofile4.svg';
import Clock from './clock.svg';
import axiosInstance from '../../axios';
import Cookies from 'js-cookie';
import { calculateDayDifference, calculateDayLeft, calculateDollar } from '../Search-jobs';
import Phd from './phd.svg';
import './index.css';
import Teacher from './teacher.svg';
import FullTime from './fullTime.svg';
import Carousel from 'react-multi-carousel';
import axios from 'axios';
import Footer from '../Footer/index.js'
import {jobTitlesArr, locoptions} from '../navbarArrays/navbarArrays';
import Select from 'react-select';
import $ from 'jquery';
import Helmet from 'react-helmet';

import { FaRegHeart } from 'react-icons/fa';
import { FaHeart } from 'react-icons/fa';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}
function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
}



const styles = {
    
    mainBGportrait: {
        background: `url(${bgimg}), #c5c8cc`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '80vw',
        paddingTop: '50vw',
        paddingLeft: '5vw',
        paddingRight: '5vw',
        paddingBottom: '3vw',
    },
    mainBGlandscape: {
        background: `url(${bgimg}), #c5c8cc`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '80vh',
        paddingTop: '50vh',
        paddingLeft: '10vh',
        paddingRight: '10vh',
        paddingBottom: '3vh',
    },
    postedJobL: {
        paddingLeft: '10vh',
        paddingRight: '10vh',
    },
    postedJobP: {
        paddingLeft: '10vw',
        paddingRight: '10vw',
    },
    cardstyle: {
        background: '#fff',
        borderRadius: '12px',
        padding: '3vh',
    },
    searchBoxBig: {
        fontSize: '14px',
        fontFamily: 'Montserrat',
        fontWeight: '600',
        background: '#fff',
        border: '1px solid #BEBEBE',
        borderRadius: '25px',
        paddingLeft: '4vh',
        paddingRight: '4vh',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    searchBoxSmall: {
        fontSize: '14px',
        fontFamily: 'Montserrat',
        fontWeight: '600',
        background: '#fff',
        border: '1px solid #BEBEBE',
        borderRadius: '25px',
        paddingLeft: '1em',
        paddingRight: '1em',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    srchField: {
        border: "none",
        borderColor: "transparent",
        outline: "none",
        width: "100%",
    },
    hiddenLabel: {
        height: 0,
        visibility: "hidden",
    }
};

const Stats = ( props ) => {
    return (
      <div className="statsBadge">
        <img src={ props.img } alt="" />
        <div>
          <div className="stat">{props.stat}</div>
          <div className="statName">{props.statName}</div>
        </div>
      </div>
    )
}

const ProfileTags = (props) => {
    return (
      <div className={`profileTag ${props.img ? null : 'tagBoldText' }`} style={{backgroundColor: '#fff'}}>
        <img src={props.img} alt="" />
        {props.text}
      </div>
    )
}

const SalaryTag = (props) => {
    return (
      <div className={`profileTag`} style={{backgroundColor: '#fff'}}>
            <div className="salaryTag">
                {[...Array(parseInt(props.n))].map((el, index) => <img src={DollarSign} alt="$" />)}
                <img src={props.img} alt="" />
            </div>
        Salary Estimate
      </div>
    )
}

const PostedJobCard = (props) => {
    
    const calculateDollar = (value) => {
        if(value > 0 && value <= 19){
            return(
                1
            )
        }else if(value >19 &&  value<=39){
            return(
                2
            )
        }else if(value > 39 && value <= 59){
            return(
                3
            )
        }else if(value > 59 && value <= 79){
            return(
                4
            )
        }else if(value > 79){
            return(
                5
            )
        }
    }

    return(
        <div className="postedJobCard">
            <div className="postedTitle">{props.jobData.job_title}</div>
            <div className="postedSubtitle">Job expiry : {props.jobData.expiry_date} ({ calculateDayLeft(props.jobData.expiry_date) ? `${calculateDayLeft(props.jobData.expiry_date)} days left apply now`  : "Expired"})</div>
            <br/>
            <div className="postedTags">
                {
                    props.jobData.salary_from ? <SalaryTag n={calculateDollar(props.jobData.salary_from)}/>  : null
                }
                {
                    props.jobData.shift_type ? <ProfileTags img={Clock} text='8 Hours Shift' /> : null
                }
                {
                    props.jobData.shift_type ? <ProfileTags img={SmolBag} text='Full-time' /> : null
                }
                {
                    props.jobData.phd_required ? <ProfileTags img={Phd} text='PHD Preferred' /> : null
                }
            </div>
        </div>
        );
}
const JobCard = (props) => {
    return (
      <div className="SearchJobCard">
            <Grid container direction='row' spacing={4}>
                <Grid item xs={12} sm={6}>
                    <div className="cardStatsCont">
                        <Stats img={ briefcase } stat={ props.data.job_posted } statName="Jobs Posted" />
                        <Stats img={ EyesImg } stat={ props.data.job_views } statName="Job Views" />
                        <Stats img={ ClicksImg } stat={ props.data.clicks_apply } statName="Clicked Apply" />
                    </div>
                    <br/>
                    <br/>
                    {
                        props.data.job.length ? (
                        <div className="postedJobs">
                            <p  style={{fontFamily: 'Montserrat', fontWeight: 700, fontSize: 19 }}>Jobs Posted <a href="/employer/job-posting" style={{fontFamily: 'Montserrat', fontWeight: 400, fontSize: 14, paddingLeft: '10px', textDecoration: 'none', color: '#000'}}>view all &gt;</a></p>
                            <PostedJobCard jobData={props.data.job[0]} />
                        </div>
                        ) : null
                    }
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="cardContainer">
                        <div className="cardTitleCont">
                            <div className="cardHeader">
                                <div className="schoolLogoImg" style={{paddingRight: '1em'}}>
                                    <img src={SchoolLogo} alt={props.school}/>
                                </div>
                                <div className="cardActions">
                                    <button className='headerBtn' style={{ color: '#0667C3', fontWeight: '500', padding: '0.5em 1.5em', fontSize: '14px', border: '1px solid #0667C3', borderRadius: '20px', background: '#fff' }} onClick={()=>window.location.href='/employer/settings/distrProfile'}>Edit</button> 
                                    <button className='headerBtn' style={{ color: '#0667C3', fontWeight: '500', padding: '0.5em 1.5em', fontSize: '14px', border: '1px solid #0667C3', borderRadius: '20px', background: '#fff' }} onClick={()=>window.location.href='/employer/preview/1'}>Preview</button> 
                                </div>
                            </div>
                            <br/>
                            <div className="cardTitleBlock">
                                <div className="cardTitle">{props.data.school.district_name}</div>
                                <br/>
                                <div className="cardSchool">{props.data.school.address}</div>
                            </div>
                            <br/>
                        </div>
                        <div className="aboutInfo">
                            <div className="aboutTitle">About us</div>
                            <div className="aboutDesc">{props.data.school.about}</div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

// const FeaturedData = [
//     {
//         profile: ProfileImg1,
//         title: 'Krishna Barbe',
//         location: 'San Francisco, CA',
//     },
//     {
//         profile: ProfileImg2,
//         title: 'Annabel Rohan',
//         location: 'San Francisco, CA',
//     },
//     {
//         profile: ProfileImg3,
//         title: 'Chieko Chute',
//         location: 'San Francisco, CA',
//     },
// ];

// const RecommendedData = [
//     {
//         profile: ProfileImg1,
//         title: 'Krishna Barbe',
//         location: 'San Francisco, CA',
//     },
//     {
//         profile: ProfileImg2,
//         title: 'Annabel Rohan',
//         location: 'San Francisco, CA',
//     },
//     {
//         profile: ProfileImg3,
//         title: 'Chieko Chute',
//         location: 'San Francisco, CA',
//     },
//     {
//         profile: ProfileImg4,
//         title: 'Tynisha Obey',
//         location: 'San Francisco, CA',
//     }
// ];


const FeaturedCandidate = (props) => {
    var data = props.data;
    const [toggleHeart, setToggleHeart] = useState(false);

    let badgeCounter = 0;
    if(data.education_avail){
        badgeCounter++;
    }
    if(data.work_exp_avail){
        badgeCounter++;
    }
    if(data.phd_avail){
        badgeCounter++;
    }


    const [accessToken, setaccessToken] = useState('');
    useEffect(() => {
        if (Cookies.get('access_token')) {
            setaccessToken(Cookies.get('access_token'));
        } else {
            window.location.href = '/register';
        }
    }, [])

    const addToFavorite = (id) => {
        // console.log(id);
        setToggleHeart(!toggleHeart)
        const data = {
            // access: accessToken,
            job_seeker_id: id
        }
        console.log(data);
        axiosInstance.post('/district/save_job_seeker/', data).then(res => {
            console.log(res);
            //getData();
        }).catch(err => {
            console.log(err);
        })
    }
    return (
        <>
            <Helmet>
                <title>Dashboard | Frame Change</title>
            </Helmet>
            <div className="featuredCandidate" style={{cursor : "pointer"}}>
                    <Grid item xs={12} s={12}>
                        <Grid container direction='row' spacing={0}>
                            <Grid item xs={3} onClick={()=>window.location.href=`/candidate-profile/${data.id}`}>
                                <img className="profileImg" src={data.profile_pic ? data.profile_pic : `https://ui-avatars.com/api/?name=${data.full_name}?rounded=true`} alt={props.title} />
                            </Grid>
                            <Grid item xs={7} onClick={()=>window.location.href=`/candidate-profile/${data.id}`}>
                                <span style={{ fontWeight: '600', marginLeft: '5px' }}>{data.full_name}</span>
                                <br />
                                <span style={{ fontSize: '12px', marginLeft: '5px' }}>{data.city}, {data.state}</span>
                            </Grid>
                            <Grid direction='row' justifyContent='flex-end' container item xs={2}>
                                
                                <Grid item lg={1} onClick={() => addToFavorite(data.id)} style={{margin:'auto'}}>
                                    {toggleHeart ? <FaHeart size='1.5em' color='orange' /> : <FaRegHeart size='1.5em' />}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br />
                        <div className='postedTags' style={{ display: 'flex', flexDirection: 'row' }}>
                            {
                                data.education_avail ?
                                    <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                        <img src={Teacher} alt="" />
                                        <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} >Teacher’s license</button>
                                    </div>
                                    : null
                            }
                            {
                                data.education_avail ? null :
                                data.work_exp_avail ?
                                    <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                        <img src={FullTime} alt="" />
                                        <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} >Work Experience</button>
                                    </div>
                                    : null
                            }
                            {
                                (data.education_avail || data.work_exp_avail) ? null :
                                data.phd_avail ?
                                    <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                        <img src={Phd} alt="" />
                                        <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} >Phd completed</button>
                                    </div>
                                    : null
                            }
                            {
                                badgeCounter > 1 ? 
                                <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                    <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} >+{badgeCounter - 1} more</button>
                                </div>
                                : null
                            }
                        </div>
                    <Grid item xs={12} onClick={()=>{
                        props.openWorkExperience();
                        props.receiverID(data.id);
                    }}>
                        <div className="contactDiv" style={{ marginTop: '15px' }} >
                            <button className="contact" onMouseEnter={() => {
                                var curElem = document.getElementById("ftcontactbtn" + props.id);
                                curElem.setAttribute('src', ContactHoverIcon);
                            }} onMouseLeave={() => {
                                var curElem = document.getElementById("ftcontactbtn" + props.id);
                                curElem.setAttribute('src', ContactIcon);
                            }}><img src={ContactIcon} alt="" id={"ftcontactbtn" + props.id} />   Contact</button>
                        </div>
                    </Grid>
            </div>
        </>
    );
}

const RecommendedCandidate = (props) => {
    var data = props.data;
    const [toggleHeart, setToggleHeart] = useState(false)
    const [accessToken, setaccessToken] = useState('');
    useEffect(() => {
        if (Cookies.get('access_token')) {
            setaccessToken(Cookies.get('access_token'));
        } else {
            window.location.href = '/register';
        }
    }, [])

    const addToFavorite = (id) => {
        // console.log(id);
        setToggleHeart(!toggleHeart)
        const data = {
            // access: accessToken,
            job_seeker_id: id
        }
        console.log(data);
        axiosInstance.post('/district/save_job_seeker/', data).then(res => {
            console.log(res);
            //getData();
        }).catch(err => {
            console.log(err);
        })
    }
    return (
        <div className="recommendedCandidate" style={{ width: '100%', cursor:'pointer', height: '100%' }}>
            <Grid container direction='column'>
                <Grid item xs={12}>
                    <Grid container direction='row' spacing={4}>
                        <Grid item xs={3} onClick={()=>window.location.href=`/candidate-profile/${data.id}`}>
                            <img className="profileImg"  src={data.profile_pic ? data.profile_pic : `https://ui-avatars.com/api/?name=${data.full_name}?rounded=true`} alt={data.full_name} />
                        </Grid>
                        <Grid item xs={6} onClick={()=>window.location.href=`/candidate-profile/${data.id}`}>
                            <span style={{ fontWeight: '600', marginLeft: '5px'  }}>{data.full_name}</span>
                            <br />
                            <span style={{ fontSize: '12px', marginLeft: '5px'  }}>{data.city}. {data.state}</span>
                        </Grid>
                        <Grid direction='row' justifyContent='flex-end' container item xs={3}>
                            {/* <button className='heartButton' style={{ border: 'none', background: '#fff' }} onClick={() => {
                                var curEl = document.getElementById('recommendedheart' + props.id);
                                if (curEl.getAttribute('src') === HeartIcon) {
                                    curEl.setAttribute('src', HeartOnIcon);
                                } else {
                                    curEl.setAttribute('src', HeartIcon);
                                }
                            }}>
                                <img src={HeartIcon} alt="Favourite" style={{ width: '100%', height: '100%' }} id={'recommendedheart' + props.id} />
                            </button> */}
                            <Grid item lg={1} onClick={() => addToFavorite(data.id)} style={{margin:'auto'}}>
                                {toggleHeart ? <FaHeart size='1.5em' color='orange' /> : <FaRegHeart size='1.5em' />}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <br />
                <Grid item xs={12} >
                    <Grid container direction='row' spacing={4}>
                        <Grid item xs={10} onClick={()=>window.location.href=`/candidate-profile/${data.id}`}>
                            <div className='postedTags'>
                                {
                                    data.education_avail ?
                                        <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                            <img src={Teacher} alt="" />
                                            <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} >Teacher’s license</button>
                                        </div> : null
                                }
                                {
                                    data.work_exp_avail ?
                                        <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                            <img src={FullTime} alt="" />
                                            <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} > Work Experience</button>
                                        </div> : null
                                }
                                {
                                    data.phd_avail ?
                                        <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                            <img src={Phd} alt="" />
                                            <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} >Phd completed</button>
                                        </div> : null
                                }
                                <div style={{ border: '1px solid #E4E8F1', margin: '5px', background: '#FFF', height: '34px', padding: '0 10px', borderRadius: '25px', display: 'flex', alignItems: 'center' }}    >
                                    <img src={FullTime} alt="" />
                                    <button style={{ background: '#FFF', border: 'none', fontSize: '12px' }} >Full Time, Part Time</button>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} onClick={()=>{
                            props.openWorkExperience();
                            props.receiverID(data.id);
                        }}>
                            <div className="contactDiv" >
                                <button className="contact" onMouseEnter={() => {
                                    var curElem = document.getElementById("ftcontactbtn" + props.id);
                                    curElem.setAttribute('src', ContactHoverIcon);
                                }} onMouseLeave={() => {
                                    var curElem = document.getElementById("ftcontactbtn" + props.id);
                                    curElem.setAttribute('src', ContactIcon);
                                }}><img src={ContactIcon} alt="" id={"ftcontactbtn" + props.id} />   Contact</button>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

const FeaturedCandidates = (props) => {

    const { height, width } = useWindowDimensions();

    const responsive1 = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 3,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 70
        }
    };

    return (
        <div className={width > height ? "featuredCandidatesL" : "featuredCandidatesP"}>
            <Typography style={{ fontSize: '28px', fontStyle: "Work Sans", fontWeight: '600', color: '#000', marginBottom: '20px', marginTop: '40px' }}>Featured Candidates</Typography>
            <Carousel
                ssr
                partialVisbile={false}
                itemClass="image-item"
                className="featuredCandidateCarousel"
                animation='slide'
                infinite={true}
                removeArrowOnDeviceType={["tablet", "mobile"]}
                autoPlaySpeed={5000}
                autoPlay
                responsive={responsive1}>
                    {props.featuredCandidates.map((candidate, i) => {
                        return(
                            <FeaturedCandidate openWorkExperience = {props.openWorkExperience} data={candidate} id={i} receiverID={props.receiverID} />
                        );
                    })}
            
            </Carousel>
        </div>
    );
}

const RecommendedCandidates = (props) => {

    const { height, width } = useWindowDimensions();

    
    const responsive1 = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 3,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 70
        }
    };


    return (
        <div className={width > height ? "recommendedCandidatesL" : "recommendedCandidatesP"}>
            <Typography style={{ fontSize: '28px', fontStyle: "Work Sans", fontWeight: '600', color: '#000', marginBottom: '20px', marginTop: '40px' }}>Recommended Candidates</Typography>
            <Carousel
                ssr
                partialVisbile={false}
                itemClass="image-item"
                className="featuredCandidateCarousel"
                animation='slide'
                infinite={true}
                removeArrowOnDeviceType={["tablet", "mobile"]}
                autoPlaySpeed={5000}
                autoPlay
                responsive={responsive1}>
                    {props.recommendedCandidates.map((candidate, i) => {
                        return(
                            <FeaturedCandidate openWorkExperience = {props.openWorkExperience} data={candidate} id={i} receiverID={props.receiverID} />
                        );
                    })}
            
            </Carousel>
        </div>
    );
}

const SearchBarBig = (props) => {
    const [searchCandidate, setsearchCandidate] = useState('');
    const [searchLocation, setsearchLocation] = useState('');

    return(
        <>
            <React.Fragment>
                <Grid item sm={10}>
                    <div className="searchBoxBig" style={styles.searchBoxBig}>
                        <Grid container direction='row' spacing={2} sm={10} style={{alignItems: 'center'}}>
                            <Grid item xs={'auto'} style={{width: '50%'}}>
                                <Grid container direction='row' spacing={2} style={{alignItems: 'center', width: '100%', flexWrap: 'nowrap'}}>
                    <Grid item xs={'auto'} style={{paddingRight: '2px'}}>
                        <img src={srch} alt="Search by Location"/>
                    </Grid>
                    <Grid item xs={'auto'} style={{width: '100%'}}>
                        <div style={styles.hiddenLabel} aria-hidden="true">Search Candidate by Job Title</div>
                        <Select
                            // isMulti
                            // className=''
                            id='jobTitleID'
                            options={jobTitlesArr}
                            onChange={e=>setsearchCandidate(e)}
                            value={searchCandidate}
                            isClearable={true}
                            // onChange={e => setjobTitleSearch(e.value)}
                            className='stateDD'
                            placeholder= 'Job Title'
                        />
                    </Grid>
                </Grid>
                            </Grid>
                            <Grid item xs={'auto'} style={{width: '50%'}}>
                                <Grid container direction='row' spacing={2} style={{alignItems: 'center', width: '100%', flexWrap: 'nowrap'}}>
                                    <Grid item xs={'auto'} style={{paddingRight: '2px'}}>
                                        <img src={pin} alt="Search by Location"/>
                                    </Grid>
                                    <Grid item xs={'auto'} style={{width: '100%'}}>
                                        <div style={styles.hiddenLabel} aria-hidden="true">Search Job by State</div>
                                        <Select
                                            // isMulti
                                            // className=''
                                            id='locationID'
                                            options={locoptions}
                                            onChange={e=>setsearchLocation(e)}
                                            value={searchLocation}
                                            // onChange={e => setlocationSearch(e.value)}
                                            className='stateDD'
                                            placeholder= 'Search by state'
                                            isClearable = {true}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
                <Grid item sm={2}>
                    <Button id='srchButton' onClick={e=>props.handleCandidateSearch(searchCandidate, searchLocation)}  style={{ textTransform: 'none', fontSize: "14px", fontFamily: 'Montserrat', background: 'linear-gradient(109.78deg, #FFCF20 -15.8%, #FD8012 111.31%)', color: '#FFF', fontWeight: '600', borderRadius: '25px', padding: '10px', minWidth: '100%' }} variant="contained" >Search</Button>
                </Grid>
            </React.Fragment>
        {/* <Grid item sm={10}>
            <div className="searchBoxBig" style={styles.searchBoxBig}>
                <Grid container direction='row' spacing={1}>
                    <Grid item xs={'auto'}>
                        <Grid container direction='row' spacing={2}>
                            <Grid item xs={'auto'}>
                                <img src={srch} alt="Search by Title"/>
                            </Grid>
                            <Grid item xs={'true'}>
                                <div style={styles.hiddenLabel} aria-hidden="true">Search Candidate by Job Title</div>
                                <input value={searchCandidate} onChange={e=>setsearchCandidate(e.target.value)} type="text" placeholder="Search Candidate by Job Title" style={styles.srchField} />
                                <Select
                                    isMulti
                                    className=''
                                    id='jobTitleID'
                                    options={jobTitlesArr}
                                    onChange={e => setjobTitleSearch(e.value)}
                                    className='stateDD'
                                    placeholder= 'Job Title'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={'auto'}>
                        <Grid container direction='row' spacing={2}>
                            <Grid item xs={'auto'}>
                                <img src={pin} alt="Search by Location"/>
                            </Grid>
                            <Grid item xs={'auto'}>
                                <div style={styles.hiddenLabel} aria-hidden="true">Location or Zip Code</div>
                                <input value={searchLocation} onChange={e=>setsearchLocation(e.target.value)} type="text" placeholder="Location or Zip Code" style={styles.srchField} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Grid>
        <Grid item sm={2}>
            <Button id='srchButton' onClick={e=>props.handleCandidateSearch(searchCandidate, searchLocation)} style={{ textTransform: 'none', fontSize: "14px", fontFamily: 'Montserrat', background: '#EB881B', color: '#FFF', fontWeight: '600', borderRadius: '25px', padding: '10px', minWidth: '100%' }} variant="contained" >Search</Button>
        </Grid> */}
        </>
    );
}

const SearchBarSmall = (props) => {
    const [searchCandidate, setsearchCandidate] = useState('');
    const [searchLocation, setsearchLocation] = useState('');

    return(
        <>
            <React.Fragment>
                <Grid item xs={12}>
                    <Grid container direction='column' spacing={1}>
                        <Grid item xs={12}>
                            <div className="searchBoxSmall" style={styles.searchBoxSmall}>
                                <Grid container direction='row' spacing={2} style={{alignItems: 'center', width: '100%', flexWrap: 'nowrap'}}>
                        <Grid item xs={'auto'} style={{paddingRight: '2px'}}>
                            <img src={srch} alt="Search by Location"/>
                        </Grid>
                        <Grid item xs={'auto'} style={{width: '100%'}}>
                            <div style={styles.hiddenLabel} aria-hidden="true">Search Candidate by Job Title</div>
                            <Select
                                // isMulti
                                // className=''
                                id='jobTitleID'
                                options={jobTitlesArr}
                                onChange={e=>setsearchCandidate(e)}
                                value={searchCandidate}
                                isClearable={true}
                                // onChange={e => setjobTitleSearch(e.value)}
                                className='stateDD'
                                placeholder= 'Job Title'
                            />
                        </Grid>
                    </Grid>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="searchBoxSmall" style={styles.searchBoxSmall}>
                                <Grid container direction='row' spacing={1} style={{alignItems: 'center', width: '100%', flexWrap: 'nowrap'}}>
                        <Grid item xs={'auto'} style={{paddingRight: '2px'}}>
                            <img src={pin} alt="Search by Location"/>
                        </Grid>
                        <Grid item xs={'auto'} style={{width: '100%'}}>
                            <div style={styles.hiddenLabel} aria-hidden="true">State</div>
                            <Select
                                // isMulti
                                // className=''
                                id='locationID'
                                options={locoptions}
                                onChange={e=>setsearchLocation(e)}
                                value={searchLocation}
                                // onChange={e => setlocationSearch(e.value)}
                                className='stateDD'
                                placeholder= 'Search by state'
                                isClearable = {true}

                            />
                        </Grid>
                    </Grid>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <Button id='srchButton' onClick={e=>props.handleCandidateSearch(searchCandidate, searchLocation)} style={{ textTransform: 'none', fontSize: "14px", fontFamily: 'Montserrat', background: 'linear-gradient(109.78deg, #FFCF20 -15.8%, #FD8012 111.31%)', color: '#FFF', fontWeight: '600', borderRadius: '25px', padding: '10px', minWidth: '100%' }} variant="contained" >Search</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        </>
        // <Grid item xs={12}>
        //     <Grid container direction='column' spacing={1}>
        //         <Grid item xs={12}>
        //             <div className="searchBoxSmall" style={styles.searchBoxSmall}>
        //                 <Grid container direction='row' spacing={1}>
        //                     <Grid item xs={'auto'}>
        //                         <img src={srch} alt="Search by Title"/>
        //                     </Grid>
        //                     <Grid item xs={'auto'}>
        //                         <input type="text" onChange={e=>setsearchCandidate(e.target.value)} value={searchCandidate} placeholder="Search by Job Title" style={styles.srchField} />
        //                     </Grid>
        //                 </Grid>
        //             </div>
        //         </Grid>
        //         <Grid item xs={12}>
        //             <div className="searchBoxSmall" style={styles.searchBoxSmall}>
        //                 <Grid container direction='row' spacing={1}>
        //                     <Grid item xs={'auto'}>
        //                         <img src={pin} alt="Search by Location"/>
        //                     </Grid>
        //                     <Grid item xs={'auto'}>
        //                         <input type="text" placeholder="Location or Zip Code" onChange={e=>setsearchLocation(e.target.value)} value={searchLocation} style={styles.srchField} />
        //                     </Grid>
        //                 </Grid>
        //             </div>
        //         </Grid>
        //         <Grid item xs={12}>
        //             <Button id='srchButton' onClick={e=>props.handleCandidateSearch(searchCandidate, searchLocation)} style={{ textTransform: 'none', fontSize: "14px", fontFamily: 'Montserrat', background: '#EB881B', color: '#FFF', fontWeight: '600', borderRadius: '25px', padding: '10px', minWidth: '100%' }} variant="contained" >
        //                 Search
        //             </Button>
        //         </Grid>
        //     </Grid>
        // </Grid>
    );
}


function EmployerMainDashboard(){
    const { height, width } = useWindowDimensions();

    const [accessToken, setaccessToken] = useState('');
    useEffect(() => {
        if ( Cookies.get( 'access_token' ) ) {
            setaccessToken( Cookies.get( 'access_token' ) );
        } else {
            window.location.href = '/register';
        }
    }, [])

    useEffect(()=>{
        if(accessToken.length > 0){
            getData();
        }
    }, [accessToken])

    const [info, setinfo] = useState({
        job_posted : 0,
        job_views : 0,
        job : [],
        school : {
            about: null,
            address: null,
            avg_graduation_rate: null,
            avg_teacher_salary: null,
            city: null,
            district_name: null,
            employee_benefits: null,
            exp_per_student: null,
            free_or_reduced_lunch: null,
            highest_grade: null,
            id: null,
            institution_type: null,
            instruction: null,
            latitude: null,
            longitude: null,
            lowest_grade: null,
            median_home_value: null,
            median_household_income: null,
            median_rent: null,
            no_of_schools: null,
            no_of_students: null,
            no_of_teachers: null,
            other: null,
            percent_proficient_maths: null,
            percent_proficient_reading: null,
            phone: null,
            salary_info: null,
            shape_area: null,
            shape_length: null,
            state: null,
            student_to_teacher_ratio: null,
            support_services: null,
            teachers_in_1_2_year: null,
            total_employee_benefits: null,
            total_salaries: null,
            website: null,
            zipcode: null,
        }
    })

    const [featuredCandidates, setfeaturedCandidates] = useState([]);
    const [recommendedCandidates, setrecommendedCandidates] = useState([]);

    const [featuredCandidatesLoader, setfeaturedCandidatesLoader] = useState(false);

    const [jobs, setJobs] = useState([])


    const getData = () => {
        setfeaturedCandidatesLoader(true);
        axiosInstance.get('/district/dashboard').then(res=>{
            console.log(res.data.data);
            setinfo(res.data.data);
            setfeaturedCandidates(res.data.data.featured_candidates.slice(0, 8));
            setrecommendedCandidates(res.data.data.recommended_candidates.slice(0, 4));
            setfeaturedCandidatesLoader(false);
        }).catch(err=>{
            console.log(err);
        })

        axiosInstance.get(`/district/get_jobs/?page=1`).then(res => setJobs(res.data.results))

    }

    const handleCandidateSearch = (candidateSearch, locationSearch) => {


        localStorage.setItem('candidateKeyword', candidateSearch ? candidateSearch.value : '');
        localStorage.setItem('candidateLocation', locationSearch ? locationSearch.value : '');
        window.location.href = '/search-candidate';

    }

    const history = useHistory();
    const [workExperienceForm, setWorkExperienceForm] = useState( false );
    const [activeJob, setActiveJob] = useState();
    const [receiverID, setreceiverID] = useState(null);

    const WorkExperienceForm = (props) => {

    const handleSendInvite = () => {
        axiosInstance.post('/messaging/create_room/', {
            // access: accessToken,
            receiver_id: receiverID,
            job_id: activeJob
        }).then(res => {
            history.push(`/message?room_id=${res.data.room_id}`);
        })
    }

    const changeStyle = (e) => {
        Array.from(document.getElementsByClassName('modal_items')).map(item=>{
        if(item.classList.contains('modal_active')){
            item.classList.remove('modal_active');
        }
        })
        document.getElementById(`grid_id_${e}`).classList.add('modal_active');
    }

    return (
    <div>
        <div style={{ marginRight: '3em', marginLeft: '3em', display: "flex", flexDirection: 'column' }}>
            <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Send Job Invite
            <p style={{fontSize : '15px', color : '#888282'}}>Click on a Job Post to select and send Invite</p>
            </Typography>
            <br />
            <form >
                    <Grid  container item spacing={3} style={{display : 'flex', justifyContent : 'center'}} >
                        {
                            jobs.map((e, i)=>{
                                return(
                                    <Grid key={i} className='modal_items' id={`grid_id_${i}`} item lg={12} style={{
                                        borderRadius : '10px', border : '1px solid black', marginBottom : '15px', cursor : 'pointer'
                                        }} onClick={()=>{changeStyle(i); setActiveJob(e.id)}} >
                                        <div style={{display : 'flex', flexDirection : 'column', justifyContent : 'space-between'}} >
                                        <div >
                                            <h5>{e.job_title}</h5>
                                            <p style={{color : '#504b4b'}}>{e.district}</p>
                                        </div>
                                        <div style={{display : 'flex', justifyContent : 'space-between'}}>
                                            <p className='workExp_subdiv'>Posted on {e.expiry_date}</p>
                                            <p className='workExp_subdiv'>Job Expires : {e.date_posted}</p>
                                        </div>
                                        </div>
                                    </Grid>
                                )
                            })
                        }                          
                    </Grid>
            </form>

        </div>
        <div className="btnProfileModalCont">
        <button className='btnContCancelBtn' id='work_exp_close_btn' onClick={props.closeModal}>
            Cancel
        </button>
        <button className='btnContSaveBtn' onClick={handleSendInvite}>
            Send Invite
        </button>
        </div>
    </div>
    )
}




    return(
        <div className='mainContainer'>
            <NavBar_emp />
            <div classname="bgimg" style={ height > width ? styles.mainBGportrait : styles.mainBGlandscape}>
                <Paper style={styles.cardstyle} elevation={0}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography style={{fontSize: '23', fontFamily: 'Montserrat', fontWeight: '600'}}>Candidate Search</Typography>
                        </Grid>
                        {width > 800 ? <SearchBarBig handleCandidateSearch={handleCandidateSearch} /> : <SearchBarSmall handleCandidateSearch={handleCandidateSearch} />}
                    </Grid>
                </Paper>
            </div>
            <br/>
            <br/>
            {Cookies.get( 'first_time_onboarding' ) === 'done' ? null : <FirstTimeOnboard />}
            
            <div className="mainContent">
                <div className="postedJob" style={ height > width ? styles.postedJobP : styles.postedJobL}>
                    <JobCard data={info}/>
                </div>
                <br/>
                <div className="featured">
                    {
                        featuredCandidatesLoader ? <CircularProgress style={{ color: 'green', display : 'flex', width :'100vw', marginBottom : '20px', justifyContent: 'center' }} /> :
                        <FeaturedCandidates featuredCandidates = {featuredCandidates} openWorkExperience={()=>setWorkExperienceForm(true)} receiverID={(id)=>setreceiverID(id)} />
                    }
                </div>
                <br/>
                <div className="recommended">
                    {
                        featuredCandidatesLoader ? <CircularProgress style={{ color: 'green', display : 'flex', width :'100vw', justifyContent: 'center', marginTop : '20px' }} /> :
                        <RecommendedCandidates recommendedCandidates = {recommendedCandidates} openWorkExperience={()=>setWorkExperienceForm(true)} receiverID={(id)=>setreceiverID(id)} />
                    }
                </div>
            </div>
            <Footer />
        </div>
    ); 


    function FirstTimeOnboard () {
        return <div className={width > height ? "featuredCandidatesL" : "featuredCandidatesP"}>
            <h2 style={{fontWeight: '600'}}>Lets get started</h2>
            <p style={ { marginBottom: '40px' } }>Here are some things you can start setting up for an effective workflow.</p>
            <div>
                <div className="firstDashCard" >
                    <div><svg width="77" height="45" viewBox="0 0 77 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M47.5087 9.56662C47.5087 14.85 42.9848 19.1332 37.4044 19.1332C31.8241 19.1332 27.3008 14.8501 27.3008 9.56662C27.3008 4.28323 31.8241 0 37.4044 0C42.9848 0 47.5087 4.2831 47.5087 9.56662Z" fill="#0CBB67" />
                        <path d="M22.4666 9.24248C22.4666 13.22 19.0979 16.4445 14.9423 16.4445C10.7866 16.4445 7.41797 13.22 7.41797 9.24248C7.41797 5.2655 10.7866 2.04102 14.9423 2.04102C19.0979 2.04102 22.4666 5.2655 22.4666 9.24248Z" fill="#0CBB67" />
                        <path d="M68.9002 9.24248C68.9002 13.22 65.5315 16.4445 61.3759 16.4445C57.2202 16.4445 53.8516 13.22 53.8516 9.24248C53.8516 5.2655 57.2202 2.04102 61.3759 2.04102C65.5315 2.04102 68.9002 5.2655 68.9002 9.24248Z" fill="#0CBB67" />
                        <path d="M22.7874 25.3658C23.6474 24.7207 23.54 23.431 22.68 22.8933C20.4229 21.4962 17.7356 20.7436 14.9408 20.7436C7.09422 20.6362 0.537598 26.7634 0 34.5026C0 35.1478 0.429719 35.5775 0.9674 35.5775H13.8659C14.511 35.5775 14.9407 35.2552 15.263 34.7175C16.9829 31.0628 19.5628 27.8383 22.7873 25.3658L22.7874 25.3658Z" fill="#0CBB67" />
                        <path d="M61.3774 20.6367C58.1529 20.6367 55.1433 21.7115 52.6708 23.4315C51.8108 23.9692 51.8108 25.259 52.5634 25.796C55.4656 28.1605 57.9381 31.1707 59.5501 34.7175C59.7649 35.2552 60.3026 35.5775 60.9471 35.5775H75.3504C75.9955 35.5775 76.4252 35.0398 76.3178 34.5027C75.7806 26.764 69.2237 20.6371 61.3769 20.6371L61.3774 20.6367Z" fill="#0CBB67" />
                        <path d="M37.4074 24.7227C26.8734 24.7227 18.1672 32.8915 17.414 43.3175C17.3066 44.07 17.9517 44.7145 18.8111 44.7145H56.1099C56.8625 44.7145 57.507 44.0694 57.507 43.3175C56.6476 32.9989 47.9409 24.7227 37.4072 24.7227H37.4074Z" fill="#0CBB67" />
                    </svg>
                    </div>
                    <div style={ { width: '450px', maxWidth: '100%' } }>
                        <h3>Invite Team Members</h3>
                        <p style={ { marginBottom: '32px' } }>You can add team members to help you with the hiring process.</p>
                        <div className="copyToClipBoardCont"  onClick={ () => {
                            navigator.clipboard.writeText( 'www.fc.com/employer/signup' );
                            $("#copy_text").fadeIn(200);
                        } }>
                            <div>www.fc.unisight.com/employer/signup</div>
                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.5342 0.251981H3.96334C3.58959 0.252082 3.23108 0.400641 2.96671 0.664928C2.70223 0.929194 2.55348 1.2876 2.55317 1.66136V2.91683L1.46815 2.91693C1.0945 2.91734 0.736193 3.066 0.471926 3.33027C0.20766 3.59453 0.0589795 3.95284 0.0585938 4.32649V12.8973C0.0589955 13.271 0.207657 13.6293 0.471926 13.8935C0.736193 14.1577 1.0945 14.3063 1.46815 14.3067H10.039C10.4128 14.3066 10.7713 14.158 11.0356 13.8937C11.3001 13.6295 11.4489 13.2711 11.4492 12.8973V11.6417H12.535C12.9087 11.6413 13.267 11.4927 13.5312 11.2284C13.7955 10.9641 13.9442 10.6058 13.9446 10.2322V1.66133C13.9442 1.28757 13.7954 0.929166 13.5309 0.664899C13.2666 0.400633 12.9081 0.252056 12.5342 0.251953V0.251981ZM10.57 12.8973C10.5699 13.038 10.5138 13.173 10.4143 13.2725C10.3147 13.3721 10.1797 13.4281 10.039 13.4282H1.46813C1.32741 13.4281 1.1924 13.3721 1.09286 13.2725C0.993316 13.173 0.937266 13.038 0.937166 12.8973V4.32642C0.937266 4.18569 0.993316 4.05068 1.09286 3.95114C1.1924 3.8516 1.3274 3.79555 1.46813 3.79535H10.039C10.1797 3.79555 10.3147 3.8516 10.4143 3.95114C10.5138 4.05068 10.5699 4.18568 10.57 4.32642V12.8973ZM13.0651 10.2322C13.065 10.373 13.009 10.508 12.9095 10.6075C12.8099 10.707 12.6749 10.7631 12.5342 10.7633H11.4492V4.32648C11.4489 3.95283 11.3002 3.59453 11.0359 3.33026C10.7718 3.06599 10.4135 2.91731 10.0398 2.91693H3.43328V1.66135C3.43338 1.52062 3.48943 1.38561 3.58897 1.28607C3.68851 1.18653 3.82351 1.13048 3.96424 1.13038H12.5343C12.675 1.13048 12.8101 1.18653 12.9096 1.28607C13.0091 1.38562 13.0652 1.52062 13.0653 1.66135L13.0651 10.2322Z" fill="#0570D2" />
                            </svg>

                        </div>
                        <span className='text-success' id="copy_text" style={{'fontWeight' : '600', 'display' : 'none'}}> Copied!</span>

                        <p style={ { marginTop: '16px' } }>Share the above link and ask the person to signup.</p>
                    </div>
                    <div style={ { marginLeft: 'auto', alignSelf: 'end', cursor: 'pointer' } } onClick={() => window.location.href = '/employer/settings/teamPage'}><svg width="118" height="20" viewBox="0 0 118 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.0135 4.8L7.13353 16H5.08553L0.189531 4.8H2.44553L6.17353 13.44L9.93353 4.8H12.0135ZM12.7615 7.456H14.7615V16H12.7615V7.456ZM13.7695 6.048C13.4069 6.048 13.1029 5.936 12.8575 5.712C12.6122 5.47733 12.4895 5.18933 12.4895 4.848C12.4895 4.50667 12.6122 4.224 12.8575 4C13.1029 3.76533 13.4069 3.648 13.7695 3.648C14.1322 3.648 14.4362 3.76 14.6815 3.984C14.9269 4.19733 15.0495 4.46933 15.0495 4.8C15.0495 5.152 14.9269 5.45067 14.6815 5.696C14.4469 5.93067 14.1429 6.048 13.7695 6.048ZM25.0985 11.776C25.0985 11.9147 25.0879 12.112 25.0665 12.368H18.3625C18.4799 12.9973 18.7839 13.4987 19.2745 13.872C19.7759 14.2347 20.3945 14.416 21.1305 14.416C22.0692 14.416 22.8425 14.1067 23.4505 13.488L24.5225 14.72C24.1385 15.1787 23.6532 15.5253 23.0665 15.76C22.4799 15.9947 21.8185 16.112 21.0825 16.112C20.1439 16.112 19.3172 15.9253 18.6025 15.552C17.8879 15.1787 17.3332 14.6613 16.9385 14C16.5545 13.328 16.3625 12.5707 16.3625 11.728C16.3625 10.896 16.5492 10.1493 16.9225 9.488C17.3065 8.816 17.8345 8.29333 18.5065 7.92C19.1785 7.54667 19.9359 7.36 20.7785 7.36C21.6105 7.36 22.3519 7.54667 23.0025 7.92C23.6639 8.28267 24.1759 8.8 24.5385 9.472C24.9119 10.1333 25.0985 10.9013 25.0985 11.776ZM20.7785 8.96C20.1385 8.96 19.5945 9.152 19.1465 9.536C18.7092 9.90933 18.4425 10.4107 18.3465 11.04H23.1945C23.1092 10.4213 22.8479 9.92 22.4105 9.536C21.9732 9.152 21.4292 8.96 20.7785 8.96ZM39.8714 7.456L36.7194 16H34.7994L32.5914 10.112L30.3514 16H28.4314L25.2954 7.456H27.1834L29.4394 13.76L31.7914 7.456H33.4714L35.7754 13.792L38.0954 7.456H39.8714ZM55.8124 7.36C56.8897 7.36 57.7431 7.67467 58.3724 8.304C59.0017 8.92267 59.3164 9.856 59.3164 11.104V16H57.3164V11.36C57.3164 10.6133 57.1511 10.0533 56.8204 9.68C56.4897 9.296 56.0151 9.104 55.3964 9.104C54.7244 9.104 54.1857 9.328 53.7804 9.776C53.3751 10.2133 53.1724 10.8427 53.1724 11.664V16H51.1724V11.36C51.1724 10.6133 51.0071 10.0533 50.6764 9.68C50.3457 9.296 49.8711 9.104 49.2524 9.104C48.5697 9.104 48.0257 9.32267 47.6204 9.76C47.2257 10.1973 47.0284 10.832 47.0284 11.664V16H45.0284V7.456H46.9324V8.544C47.2524 8.16 47.6524 7.86667 48.1324 7.664C48.6124 7.46133 49.1457 7.36 49.7324 7.36C50.3724 7.36 50.9377 7.48267 51.4284 7.728C51.9297 7.96267 52.3244 8.31467 52.6124 8.784C52.9644 8.336 53.4177 7.98933 53.9724 7.744C54.5271 7.488 55.1404 7.36 55.8124 7.36ZM65.4703 16.112C64.6063 16.112 63.8276 15.9253 63.1343 15.552C62.4409 15.1787 61.8969 14.6613 61.5023 14C61.1183 13.328 60.9263 12.5707 60.9263 11.728C60.9263 10.8853 61.1183 10.1333 61.5023 9.472C61.8969 8.81067 62.4409 8.29333 63.1343 7.92C63.8276 7.54667 64.6063 7.36 65.4703 7.36C66.345 7.36 67.1289 7.54667 67.8223 7.92C68.5156 8.29333 69.0543 8.81067 69.4383 9.472C69.833 10.1333 70.0303 10.8853 70.0303 11.728C70.0303 12.5707 69.833 13.328 69.4383 14C69.0543 14.6613 68.5156 15.1787 67.8223 15.552C67.1289 15.9253 66.345 16.112 65.4703 16.112ZM65.4703 14.4C66.2063 14.4 66.8143 14.1547 67.2943 13.664C67.7743 13.1733 68.0143 12.528 68.0143 11.728C68.0143 10.928 67.7743 10.2827 67.2943 9.792C66.8143 9.30133 66.2063 9.056 65.4703 9.056C64.7343 9.056 64.1263 9.30133 63.6463 9.792C63.1769 10.2827 62.9423 10.928 62.9423 11.728C62.9423 12.528 63.1769 13.1733 63.6463 13.664C64.1263 14.1547 64.7343 14.4 65.4703 14.4ZM73.5268 8.704C74.1028 7.808 75.1161 7.36 76.5668 7.36V9.264C76.3961 9.232 76.2415 9.216 76.1028 9.216C75.3241 9.216 74.7161 9.44533 74.2788 9.904C73.8415 10.352 73.6228 11.0027 73.6228 11.856V16H71.6228V7.456H73.5268V8.704ZM85.8973 11.776C85.8973 11.9147 85.8866 12.112 85.8653 12.368H79.1613C79.2786 12.9973 79.5826 13.4987 80.0733 13.872C80.5746 14.2347 81.1933 14.416 81.9293 14.416C82.868 14.416 83.6413 14.1067 84.2493 13.488L85.3213 14.72C84.9373 15.1787 84.452 15.5253 83.8653 15.76C83.2786 15.9947 82.6173 16.112 81.8813 16.112C80.9426 16.112 80.116 15.9253 79.4013 15.552C78.6866 15.1787 78.132 14.6613 77.7373 14C77.3533 13.328 77.1613 12.5707 77.1613 11.728C77.1613 10.896 77.348 10.1493 77.7213 9.488C78.1053 8.816 78.6333 8.29333 79.3053 7.92C79.9773 7.54667 80.7346 7.36 81.5773 7.36C82.4093 7.36 83.1506 7.54667 83.8013 7.92C84.4626 8.28267 84.9746 8.8 85.3373 9.472C85.7106 10.1333 85.8973 10.9013 85.8973 11.776ZM81.5773 8.96C80.9373 8.96 80.3933 9.152 79.9453 9.536C79.508 9.90933 79.2413 10.4107 79.1453 11.04H83.9933C83.908 10.4213 83.6466 9.92 83.2093 9.536C82.772 9.152 82.228 8.96 81.5773 8.96Z" fill="#0570D2" />
                        <path d="M117.727 10.0008L110.527 17.2008V13.0865H101.27V6.91507H110.527V2.80078L117.727 10.0008Z" fill="#0570D2" />
                    </svg>
                    </div>
                </div>
            </div>
            <div>
                <div className="firstDashCard">
                    <div><svg width="49" height="78" viewBox="0 0 49 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M32.6934 31.707H16.7979C8.11291 31.707 0.984375 38.7535 0.984375 47.5206V54.9769H7.78502C7.37523 53.4199 7.78502 51.6174 9.01382 50.3886L12.5368 46.8657C13.4381 45.9644 14.6669 45.4729 15.978 45.4729C16.5519 45.4729 17.2068 45.6369 17.7806 45.8003C18.5179 44.0794 20.2388 42.8507 22.2049 42.8507H27.2029C29.1695 42.8507 30.8899 44.0795 31.6271 45.8003C32.201 45.5546 32.8559 45.4729 33.4297 45.4729C34.7408 45.4729 35.8879 45.9644 36.871 46.8657L40.394 50.3886C41.6227 51.6174 42.1149 53.4201 41.6227 54.9769H48.5064V47.5206C48.5064 38.7538 41.4599 31.707 32.6928 31.707H32.6934Z" fill="#0CBB67" />
                        <path d="M38.1834 13.5995C38.1834 21.021 32.1675 27.037 24.746 27.037C17.3246 27.037 11.3086 21.021 11.3086 13.5995C11.3086 6.17808 17.3246 0.162109 24.746 0.162109C32.1675 0.162109 38.1834 6.17808 38.1834 13.5995Z" fill="#0CBB67" />
                        <path d="M39.738 59.5656L36.0511 58.9918C35.7236 58.1722 35.6413 57.9264 35.2315 57.0252L37.4439 54.0755C37.6079 53.8297 37.6079 53.584 37.3622 53.4199L33.8392 49.897C33.6752 49.733 33.3477 49.733 33.1837 49.8153L30.234 52.0277C29.4144 51.7002 29.1687 51.6179 28.2674 51.2081L27.6936 47.5211C27.6936 47.2754 27.4478 47.1113 27.202 47.1113H22.2856C22.0399 47.1113 21.7941 47.2754 21.7941 47.5211L21.2203 51.2081C20.4007 51.5356 20.1549 51.6179 19.2537 52.0277L16.304 49.8153C16.0582 49.6512 15.8125 49.6512 15.6484 49.897L12.1255 53.4199C11.9615 53.584 11.9615 53.9114 12.0438 54.0755L14.2562 57.0252C13.9287 57.8447 13.8464 58.0905 13.4366 58.9918L9.74964 59.5656C9.50388 59.5656 9.33984 59.8113 9.33984 60.0571V65.0552C9.33984 65.3009 9.50388 65.5467 9.74964 65.5467L13.4366 66.1205C13.7641 66.9401 13.8464 67.1859 14.2562 68.0871L12.0438 71.0362C11.8797 71.282 11.8797 71.5277 12.1255 71.6918L15.6484 75.2147C15.8125 75.3787 16.14 75.3787 16.304 75.2964L19.2537 73.084C20.0733 73.4115 20.319 73.4938 21.2203 73.9036L21.7941 77.5906C21.7941 77.8363 22.0399 78.0004 22.2856 78.0004H27.2837C27.5295 78.0004 27.7752 77.8363 27.7752 77.5906L28.349 73.9036C29.1686 73.5761 29.4144 73.4938 30.3156 73.084L33.2653 75.2964C33.5111 75.4605 33.7568 75.4605 33.9209 75.2147L37.4438 71.6918C37.6078 71.5277 37.6079 71.2002 37.5255 71.0362L35.3131 68.0865C35.6406 67.2669 35.7229 67.0212 36.1327 66.1199L39.8197 65.5461C40.0654 65.5461 40.2295 65.3004 40.2295 65.0546V60.0565C40.2295 59.8113 39.9837 59.5656 39.738 59.5656L39.738 59.5656ZM24.7438 67.8409C21.7942 67.8409 19.4183 65.4651 19.4183 62.5154C19.4183 59.5657 21.7942 57.1899 24.7438 57.1899C27.6935 57.1899 30.0694 59.5657 30.0694 62.5154C30.0694 65.4651 27.6935 67.8409 24.7438 67.8409Z" fill="#0CBB67" />
                    </svg>

                    </div>
                    <div style={ { width: '550px', maxWidth: '100%' } }>
                        <h3>Manage roles and Permissions</h3>
                        <p style={ { marginBottom: '32px' } }>Assign roles to the team members it helps you mange their permission access.</p>
                        <p style={ { marginTop: '16px' } }>Here are some pre-defined roles.</p>
                        <div style={ { display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' } } onClick={() => window.location.href = '/employer/settings/userRoles'}>
                            <div className='cardIntro'>Manager</div>
                            <div className='cardIntro'>Supervisor</div>
                            <div className='cardIntro'>Superintendent</div>
                            <div className='cardIntro'>Employee</div>
                        </div>
                    </div>
                    <div style={ { marginLeft: 'auto', alignSelf: 'end', cursor: 'pointer' } } onClick={() => window.location.href = '/employer/settings/userRoles'}><svg width="118" height="20" viewBox="0 0 118 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.0135 4.8L7.13353 16H5.08553L0.189531 4.8H2.44553L6.17353 13.44L9.93353 4.8H12.0135ZM12.7615 7.456H14.7615V16H12.7615V7.456ZM13.7695 6.048C13.4069 6.048 13.1029 5.936 12.8575 5.712C12.6122 5.47733 12.4895 5.18933 12.4895 4.848C12.4895 4.50667 12.6122 4.224 12.8575 4C13.1029 3.76533 13.4069 3.648 13.7695 3.648C14.1322 3.648 14.4362 3.76 14.6815 3.984C14.9269 4.19733 15.0495 4.46933 15.0495 4.8C15.0495 5.152 14.9269 5.45067 14.6815 5.696C14.4469 5.93067 14.1429 6.048 13.7695 6.048ZM25.0985 11.776C25.0985 11.9147 25.0879 12.112 25.0665 12.368H18.3625C18.4799 12.9973 18.7839 13.4987 19.2745 13.872C19.7759 14.2347 20.3945 14.416 21.1305 14.416C22.0692 14.416 22.8425 14.1067 23.4505 13.488L24.5225 14.72C24.1385 15.1787 23.6532 15.5253 23.0665 15.76C22.4799 15.9947 21.8185 16.112 21.0825 16.112C20.1439 16.112 19.3172 15.9253 18.6025 15.552C17.8879 15.1787 17.3332 14.6613 16.9385 14C16.5545 13.328 16.3625 12.5707 16.3625 11.728C16.3625 10.896 16.5492 10.1493 16.9225 9.488C17.3065 8.816 17.8345 8.29333 18.5065 7.92C19.1785 7.54667 19.9359 7.36 20.7785 7.36C21.6105 7.36 22.3519 7.54667 23.0025 7.92C23.6639 8.28267 24.1759 8.8 24.5385 9.472C24.9119 10.1333 25.0985 10.9013 25.0985 11.776ZM20.7785 8.96C20.1385 8.96 19.5945 9.152 19.1465 9.536C18.7092 9.90933 18.4425 10.4107 18.3465 11.04H23.1945C23.1092 10.4213 22.8479 9.92 22.4105 9.536C21.9732 9.152 21.4292 8.96 20.7785 8.96ZM39.8714 7.456L36.7194 16H34.7994L32.5914 10.112L30.3514 16H28.4314L25.2954 7.456H27.1834L29.4394 13.76L31.7914 7.456H33.4714L35.7754 13.792L38.0954 7.456H39.8714ZM55.8124 7.36C56.8897 7.36 57.7431 7.67467 58.3724 8.304C59.0017 8.92267 59.3164 9.856 59.3164 11.104V16H57.3164V11.36C57.3164 10.6133 57.1511 10.0533 56.8204 9.68C56.4897 9.296 56.0151 9.104 55.3964 9.104C54.7244 9.104 54.1857 9.328 53.7804 9.776C53.3751 10.2133 53.1724 10.8427 53.1724 11.664V16H51.1724V11.36C51.1724 10.6133 51.0071 10.0533 50.6764 9.68C50.3457 9.296 49.8711 9.104 49.2524 9.104C48.5697 9.104 48.0257 9.32267 47.6204 9.76C47.2257 10.1973 47.0284 10.832 47.0284 11.664V16H45.0284V7.456H46.9324V8.544C47.2524 8.16 47.6524 7.86667 48.1324 7.664C48.6124 7.46133 49.1457 7.36 49.7324 7.36C50.3724 7.36 50.9377 7.48267 51.4284 7.728C51.9297 7.96267 52.3244 8.31467 52.6124 8.784C52.9644 8.336 53.4177 7.98933 53.9724 7.744C54.5271 7.488 55.1404 7.36 55.8124 7.36ZM65.4703 16.112C64.6063 16.112 63.8276 15.9253 63.1343 15.552C62.4409 15.1787 61.8969 14.6613 61.5023 14C61.1183 13.328 60.9263 12.5707 60.9263 11.728C60.9263 10.8853 61.1183 10.1333 61.5023 9.472C61.8969 8.81067 62.4409 8.29333 63.1343 7.92C63.8276 7.54667 64.6063 7.36 65.4703 7.36C66.345 7.36 67.1289 7.54667 67.8223 7.92C68.5156 8.29333 69.0543 8.81067 69.4383 9.472C69.833 10.1333 70.0303 10.8853 70.0303 11.728C70.0303 12.5707 69.833 13.328 69.4383 14C69.0543 14.6613 68.5156 15.1787 67.8223 15.552C67.1289 15.9253 66.345 16.112 65.4703 16.112ZM65.4703 14.4C66.2063 14.4 66.8143 14.1547 67.2943 13.664C67.7743 13.1733 68.0143 12.528 68.0143 11.728C68.0143 10.928 67.7743 10.2827 67.2943 9.792C66.8143 9.30133 66.2063 9.056 65.4703 9.056C64.7343 9.056 64.1263 9.30133 63.6463 9.792C63.1769 10.2827 62.9423 10.928 62.9423 11.728C62.9423 12.528 63.1769 13.1733 63.6463 13.664C64.1263 14.1547 64.7343 14.4 65.4703 14.4ZM73.5268 8.704C74.1028 7.808 75.1161 7.36 76.5668 7.36V9.264C76.3961 9.232 76.2415 9.216 76.1028 9.216C75.3241 9.216 74.7161 9.44533 74.2788 9.904C73.8415 10.352 73.6228 11.0027 73.6228 11.856V16H71.6228V7.456H73.5268V8.704ZM85.8973 11.776C85.8973 11.9147 85.8866 12.112 85.8653 12.368H79.1613C79.2786 12.9973 79.5826 13.4987 80.0733 13.872C80.5746 14.2347 81.1933 14.416 81.9293 14.416C82.868 14.416 83.6413 14.1067 84.2493 13.488L85.3213 14.72C84.9373 15.1787 84.452 15.5253 83.8653 15.76C83.2786 15.9947 82.6173 16.112 81.8813 16.112C80.9426 16.112 80.116 15.9253 79.4013 15.552C78.6866 15.1787 78.132 14.6613 77.7373 14C77.3533 13.328 77.1613 12.5707 77.1613 11.728C77.1613 10.896 77.348 10.1493 77.7213 9.488C78.1053 8.816 78.6333 8.29333 79.3053 7.92C79.9773 7.54667 80.7346 7.36 81.5773 7.36C82.4093 7.36 83.1506 7.54667 83.8013 7.92C84.4626 8.28267 84.9746 8.8 85.3373 9.472C85.7106 10.1333 85.8973 10.9013 85.8973 11.776ZM81.5773 8.96C80.9373 8.96 80.3933 9.152 79.9453 9.536C79.508 9.90933 79.2413 10.4107 79.1453 11.04H83.9933C83.908 10.4213 83.6466 9.92 83.2093 9.536C82.772 9.152 82.228 8.96 81.5773 8.96Z" fill="#0570D2" />
                        <path d="M117.727 10.0008L110.527 17.2008V13.0865H101.27V6.91507H110.527V2.80078L117.727 10.0008Z" fill="#0570D2" />
                    </svg>
                    </div>
                </div>
            </div>
            <div>
                <div className="firstDashCard" style={ { marginBottom: '50px' } }>
                    <div><svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.7192 8.72095C22.7192 13.4262 18.9047 17.2407 14.1995 17.2407C9.49422 17.2407 5.67969 13.4262 5.67969 8.72095C5.67969 4.0157 9.49422 0.201172 14.1995 0.201172C18.9047 0.201172 22.7192 4.0157 22.7192 8.72095Z" fill="#0CBB67" />
                        <path d="M28.3993 25.7606C28.3993 18.3767 0 18.3767 0 25.7606V37.1203H28.3993V25.7606Z" fill="#0CBB67" />
                        <path d="M51.1216 28.3167C51.1216 33.0223 47.3071 36.8364 42.6018 36.8364C37.8966 36.8364 34.082 33.0223 34.082 28.3167C34.082 23.6114 37.8966 19.7969 42.6018 19.7969C47.3071 19.7969 51.1216 23.6114 51.1216 28.3167Z" fill="#0CBB67" />
                        <path d="M28.3984 45.3563V56.716H56.7977V45.3563C56.7977 37.9724 28.3984 37.9724 28.3984 45.3563Z" fill="#0CBB67" />
                        <path d="M7.95329 42.8008H2.27344V57.0004H22.7209V51.3206H7.95329V42.8008Z" fill="#0CBB67" />
                        <path d="M45.438 14.4008H51.1178V0.201172H28.3984V5.88102H45.438V14.4008Z" fill="#0CBB67" />
                    </svg>

                    </div>
                    <div style={ { width: '450px', maxWidth: '100%' } }>
                        <h3>Communication Preferences</h3>
                        <p style={ { marginBottom: '32px' } }>Assign roles to the team members it helps you mange their permission access.</p>
                        <p style={ { marginTop: '16px' } }>Here are some pre-defined region.</p>
                        <div style={ { display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' } } onClick={() => window.location.href = '/employer/settings/commPreferences'}>
                            <div className='cardIntro'>Brooklyn</div>
                            <div className='cardIntro'>Manhattan</div>
                        </div>
                    </div>
                    <div style={ { marginLeft: 'auto', alignSelf: 'end', cursor: 'pointer' } } onClick={() => window.location.href = '/employer/settings/commPreferences'}><svg width="118" height="20" viewBox="0 0 118 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.0135 4.8L7.13353 16H5.08553L0.189531 4.8H2.44553L6.17353 13.44L9.93353 4.8H12.0135ZM12.7615 7.456H14.7615V16H12.7615V7.456ZM13.7695 6.048C13.4069 6.048 13.1029 5.936 12.8575 5.712C12.6122 5.47733 12.4895 5.18933 12.4895 4.848C12.4895 4.50667 12.6122 4.224 12.8575 4C13.1029 3.76533 13.4069 3.648 13.7695 3.648C14.1322 3.648 14.4362 3.76 14.6815 3.984C14.9269 4.19733 15.0495 4.46933 15.0495 4.8C15.0495 5.152 14.9269 5.45067 14.6815 5.696C14.4469 5.93067 14.1429 6.048 13.7695 6.048ZM25.0985 11.776C25.0985 11.9147 25.0879 12.112 25.0665 12.368H18.3625C18.4799 12.9973 18.7839 13.4987 19.2745 13.872C19.7759 14.2347 20.3945 14.416 21.1305 14.416C22.0692 14.416 22.8425 14.1067 23.4505 13.488L24.5225 14.72C24.1385 15.1787 23.6532 15.5253 23.0665 15.76C22.4799 15.9947 21.8185 16.112 21.0825 16.112C20.1439 16.112 19.3172 15.9253 18.6025 15.552C17.8879 15.1787 17.3332 14.6613 16.9385 14C16.5545 13.328 16.3625 12.5707 16.3625 11.728C16.3625 10.896 16.5492 10.1493 16.9225 9.488C17.3065 8.816 17.8345 8.29333 18.5065 7.92C19.1785 7.54667 19.9359 7.36 20.7785 7.36C21.6105 7.36 22.3519 7.54667 23.0025 7.92C23.6639 8.28267 24.1759 8.8 24.5385 9.472C24.9119 10.1333 25.0985 10.9013 25.0985 11.776ZM20.7785 8.96C20.1385 8.96 19.5945 9.152 19.1465 9.536C18.7092 9.90933 18.4425 10.4107 18.3465 11.04H23.1945C23.1092 10.4213 22.8479 9.92 22.4105 9.536C21.9732 9.152 21.4292 8.96 20.7785 8.96ZM39.8714 7.456L36.7194 16H34.7994L32.5914 10.112L30.3514 16H28.4314L25.2954 7.456H27.1834L29.4394 13.76L31.7914 7.456H33.4714L35.7754 13.792L38.0954 7.456H39.8714ZM55.8124 7.36C56.8897 7.36 57.7431 7.67467 58.3724 8.304C59.0017 8.92267 59.3164 9.856 59.3164 11.104V16H57.3164V11.36C57.3164 10.6133 57.1511 10.0533 56.8204 9.68C56.4897 9.296 56.0151 9.104 55.3964 9.104C54.7244 9.104 54.1857 9.328 53.7804 9.776C53.3751 10.2133 53.1724 10.8427 53.1724 11.664V16H51.1724V11.36C51.1724 10.6133 51.0071 10.0533 50.6764 9.68C50.3457 9.296 49.8711 9.104 49.2524 9.104C48.5697 9.104 48.0257 9.32267 47.6204 9.76C47.2257 10.1973 47.0284 10.832 47.0284 11.664V16H45.0284V7.456H46.9324V8.544C47.2524 8.16 47.6524 7.86667 48.1324 7.664C48.6124 7.46133 49.1457 7.36 49.7324 7.36C50.3724 7.36 50.9377 7.48267 51.4284 7.728C51.9297 7.96267 52.3244 8.31467 52.6124 8.784C52.9644 8.336 53.4177 7.98933 53.9724 7.744C54.5271 7.488 55.1404 7.36 55.8124 7.36ZM65.4703 16.112C64.6063 16.112 63.8276 15.9253 63.1343 15.552C62.4409 15.1787 61.8969 14.6613 61.5023 14C61.1183 13.328 60.9263 12.5707 60.9263 11.728C60.9263 10.8853 61.1183 10.1333 61.5023 9.472C61.8969 8.81067 62.4409 8.29333 63.1343 7.92C63.8276 7.54667 64.6063 7.36 65.4703 7.36C66.345 7.36 67.1289 7.54667 67.8223 7.92C68.5156 8.29333 69.0543 8.81067 69.4383 9.472C69.833 10.1333 70.0303 10.8853 70.0303 11.728C70.0303 12.5707 69.833 13.328 69.4383 14C69.0543 14.6613 68.5156 15.1787 67.8223 15.552C67.1289 15.9253 66.345 16.112 65.4703 16.112ZM65.4703 14.4C66.2063 14.4 66.8143 14.1547 67.2943 13.664C67.7743 13.1733 68.0143 12.528 68.0143 11.728C68.0143 10.928 67.7743 10.2827 67.2943 9.792C66.8143 9.30133 66.2063 9.056 65.4703 9.056C64.7343 9.056 64.1263 9.30133 63.6463 9.792C63.1769 10.2827 62.9423 10.928 62.9423 11.728C62.9423 12.528 63.1769 13.1733 63.6463 13.664C64.1263 14.1547 64.7343 14.4 65.4703 14.4ZM73.5268 8.704C74.1028 7.808 75.1161 7.36 76.5668 7.36V9.264C76.3961 9.232 76.2415 9.216 76.1028 9.216C75.3241 9.216 74.7161 9.44533 74.2788 9.904C73.8415 10.352 73.6228 11.0027 73.6228 11.856V16H71.6228V7.456H73.5268V8.704ZM85.8973 11.776C85.8973 11.9147 85.8866 12.112 85.8653 12.368H79.1613C79.2786 12.9973 79.5826 13.4987 80.0733 13.872C80.5746 14.2347 81.1933 14.416 81.9293 14.416C82.868 14.416 83.6413 14.1067 84.2493 13.488L85.3213 14.72C84.9373 15.1787 84.452 15.5253 83.8653 15.76C83.2786 15.9947 82.6173 16.112 81.8813 16.112C80.9426 16.112 80.116 15.9253 79.4013 15.552C78.6866 15.1787 78.132 14.6613 77.7373 14C77.3533 13.328 77.1613 12.5707 77.1613 11.728C77.1613 10.896 77.348 10.1493 77.7213 9.488C78.1053 8.816 78.6333 8.29333 79.3053 7.92C79.9773 7.54667 80.7346 7.36 81.5773 7.36C82.4093 7.36 83.1506 7.54667 83.8013 7.92C84.4626 8.28267 84.9746 8.8 85.3373 9.472C85.7106 10.1333 85.8973 10.9013 85.8973 11.776ZM81.5773 8.96C80.9373 8.96 80.3933 9.152 79.9453 9.536C79.508 9.90933 79.2413 10.4107 79.1453 11.04H83.9933C83.908 10.4213 83.6466 9.92 83.2093 9.536C82.772 9.152 82.228 8.96 81.5773 8.96Z" fill="#0570D2" />
                        <path d="M117.727 10.0008L110.527 17.2008V13.0865H101.27V6.91507H110.527V2.80078L117.727 10.0008Z" fill="#0570D2" />
                    </svg>
                    </div>
                </div>
            </div>
            <button style={ { marginBottom: '150px' } } className='skipBtn' onClick={() => {Cookies.set('first_time_onboarding', 'done'); window.location.reload()}}>Skip</button>

            <Modal
                open={workExperienceForm}
                onClose={() => {setWorkExperienceForm(false);}}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modalCont'><WorkExperienceForm closeModal={() => {setWorkExperienceForm(false);}} /></div>
            </Modal>
        </div>
    }
}

export default EmployerMainDashboard;
